import * as React from 'react';
import './GroupDetails.css';
import { AppStore } from '../../../../stores';
import { inject, observer } from 'mobx-react';
import GroupService from '../../../../services/GroupService';
import { IGroupMemberInfo } from '../../../../interfaces/IGroupMemberInfo';
import GroupResultBar from './groupResultBar/GroupResultBar';
import { Accordion } from '../../../accordion/Accordion';
import IconService from '../../../../services/IconService';
import * as d3 from "d3";
import Moment from 'react-moment';

import { Pivot } from '../../../pivot/Pivot';
import { useMemo, useRef } from 'react';

export interface IProps {
  id?: string;
  appStore?: AppStore;
}

export interface IState {
  typesAndScores: { type: number, score: number }[];
  members?: IGroupMemberInfo[];
  loading: boolean;
  displayType: "bar" | "donut";
}



@inject('appStore')
@observer
export default class GroupDetails extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      typesAndScores: [
        { type: 1, score: 0 },
        { type: 2, score: 0 },
        { type: 3, score: 0 },
        { type: 4, score: 0 },
        { type: 5, score: 0 },
        { type: 6, score: 0 },
        { type: 7, score: 0 },
        { type: 8, score: 0 },
        { type: 9, score: 0 },
      ],
      displayType: "bar"
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.id && props.id != this.props.id) {
      const typesAndScores = [
        { type: 1, score: 4 },
        { type: 2, score: 6 },
        { type: 3, score: 1 },
        { type: 4, score: 14 },
        { type: 5, score: 8 },
        { type: 6, score: 5 },
        { type: 7, score: 8 },
        { type: 8, score: 4 },
        { type: 9, score: 9 },
      ];
      GroupService.getGroupMemberInfoForGroup(props.id).then((groupMembersInfo: IGroupMemberInfo[]) => {
        console.log(groupMembersInfo);
        const members: any[] = [];
        groupMembersInfo.forEach((groupMemberInfo: IGroupMemberInfo) => {
          if (typesAndScores[groupMemberInfo.type - 1]) {
            members.push(groupMemberInfo);
            //typesAndScores[groupMemberInfo.type - 1].score++;
          }
        });
        this.setState({ typesAndScores, members, loading: false });
      });
    }
  }

  private showResult(): JSX.Element {
    if (this.state.displayType === "bar") {
      return (
        <>
          {this.state.typesAndScores.sort((a, b) => b.score - a.score).map((typeAndScore, index) => {
            return (
              <GroupResultBar
                key={`resultBar_${typeAndScore.type}`}
                type={typeAndScore.type}
                points={typeAndScore.score}
                scoreForWinner={this.state.typesAndScores[0].score}
                totalParticipants={59} // {this.state.members.length}
                winner={index === 0}
                backgroundColor={"#ffffff"}
                barColor={"#ffffff"}
                textColor={"#064859"}
                iconBackgroundColor={this.props.appStore?.typeTestColorLighter}
                iconTextColor={"#ffffff"}
                onClick={() => {
                }}
              />
            );
          })}
        </>
      )
    } else {
      const data: any[] = [];
      this.state.typesAndScores.sort((a, b) => b.type - a.type).reverse().map((typeAndScore, index) => {
        data.push(
          {
            legend: `Type ${typeAndScore.type}`,
            data: typeAndScore.score,
            color: this.getColorForType(typeAndScore.type),
            xAxisCalloutData: `Type ${typeAndScore.type} - ${typeAndScore.score} members`,
          }
        );
      })
      return (
        <div style={{
          height: 600,
          position: "absolute",
          width: "100%",
        }}>
          <PieChart data={[
            { name: "Mark", value: 90 },
            { name: "Robert", value: 12 },
            { name: "Emily", value: 34 },
            { name: "Marion", value: 53 },
            { name: "Nicolas", value: 98 },
          ]} width={600} height={600} />
        </div>
      )
    }
  }

  private getColorForType(type: number): string {
    switch (type) {
      case 1:
        return "#dbb463";
      case 2:
        return "#ddd961";
      case 3:
        return "#bed35e";
      case 4:
        return "#71d161";
      case 5:
        return "#68b5d1";
      case 6:
        return "#6546e5";
      case 7:
        return "#d74dca";
      case 8:
        return "#dc5374";
      case 9:
        return "#cb5559";
      default:
        return "#ffffff";
    }
  }

  render() {

    console.log(this.props.id);
    return (
      <div>
        <div
          className="groupDetailsPanelWrapper"
          style={{
            visibility: this.props.appStore && this.props.appStore!.groupToView != undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            if (this.props.appStore) {
              this.props.appStore!.groupToView = undefined;
            }
          }}
        />
        <div
          className="groupDetailsPanel"
          style={{
            right: this.props.appStore && this.props.appStore!.groupToView != undefined ? 0 : -screen.width,
          }}
        >
          <div className="editPanelCloseBtn"
            onClick={() => {
              if (this.props.appStore) {
                this.props.appStore!.groupToView = undefined;
              }
            }}
          />
          <h2>{this.props.appStore?.groupToView?.name}</h2>
          <p>{this.props.appStore?.groupToView?.description?.replace("{user}", this.props.appStore?.user?.name || "")}</p>
          {this.state.loading ?
            <>Loading...</>
            :
            <>
              <Accordion
                isMobile={this.props.appStore?.isMobile || this.props.appStore?.isIpad}
                items={[
                  {
                    title: `${63} inviterede`, //`${this.props.appStore!.groupToView?.members?.length} inviterede`,
                    icon: IconService.getIcon("People Audience", "#ffffff"),
                  }, {
                    title: `${59} ${window.loc.strings.participants}`, //`${this.state.members?.length} ${window.loc.strings.groupMembers}`,
                    icon: IconService.getIcon("People Audience", "#ffffff")
                  }, {
                    title: <span><span>Oprettet: </span><Moment format="DD/MM YYYY" local>{this.props.appStore?.groupToView?.createdAt}</Moment></span>,
                    icon: IconService.getIcon("Calendar", "#ffffff"),
                  },
                ]}
                openInPopup={(url: string) => { }}
                openInPageEmbed={(url: string) => { }}
              />
              <h3>{window.loc.strings.result}</h3>
              <Pivot
                highlightColor="#ffffff"
                textColor="#999999"
                items={[
                  {
                    key: "bar",
                    text: window.loc.strings.barChart ?? "",
                  },
                  {
                    key: "donut",
                    text: window.loc.strings.donutChart ?? "",
                  }
                ]}
                style={{
                  fontSize: "14px",
                  textTransform: "uppercase",
                }}
                selectedKey={this.state.displayType}
                select={(displayType) => {
                  this.setState({ displayType: displayType as "bar" | "donut" });
                }}
              />
              <div className={this.state.displayType === "bar" ? 'barResult' : 'donutResult'}>
                {this.state.members &&
                  this.showResult()
                }
              </div>
            </>
          }
        </div>
      </div>
    );
  }
}

type DataItem = {
  name: string;
  value: number;
};


type PieChartProps = {
  width: number;
  height: number;
  data: DataItem[];
};


const MARGIN_X = 150;
const MARGIN_Y = 50;
const INFLEXION_PADDING = 20; // space between donut and label inflexion point

export const PieChart = ({ width, height, data }: PieChartProps) => {


  const colors = [
    "#e0ac2b",
    "#e85252",
    "#6689c6",
    "#9a6fb0",
    "#a53253",
    "#69b3a2",
  ];
  const ref = useRef(null);

  const radius = Math.min(width - 2 * MARGIN_X, height - 2 * MARGIN_Y) / 2;

  const pie = useMemo(() => {
    const pieGenerator = d3.pie<any, DataItem>().value((d) => d.value);
    return pieGenerator(data);
  }, [data]);

  const arcGenerator = d3.arc();

  const shapes = pie.map((grp, i) => {
    // First arc is for the Pie
    const sliceInfo = {
      innerRadius: 0,
      outerRadius: radius,
      startAngle: grp.startAngle,
      endAngle: grp.endAngle,
    };
    const centroid = arcGenerator.centroid(sliceInfo);
    const slicePath = arcGenerator(sliceInfo);

    // Second arc is for the legend inflexion point
    const inflexionInfo = {
      innerRadius: radius + INFLEXION_PADDING,
      outerRadius: radius + INFLEXION_PADDING,
      startAngle: grp.startAngle,
      endAngle: grp.endAngle,
    };
    const inflexionPoint = arcGenerator.centroid(inflexionInfo);

    const isRightLabel = inflexionPoint[0] > 0;
    const labelPosX = inflexionPoint[0] + 50 * (isRightLabel ? 1 : -1);
    const textAnchor = isRightLabel ? "start" : "end";
    const label = grp.data.name + " (" + grp.value + ")";

    return (
      <g
        key={i}
        className={"slice"}
        onMouseEnter={() => {
          if (ref.current) {
            ref.current.classList.add("hasHighlight");
          }
        }}
        onMouseLeave={() => {
          if (ref.current) {
            ref.current.classList.remove("hasHighlight");
          }
        }}
      >
        <path d={slicePath} fill={colors[i]} />
        <circle cx={centroid[0]} cy={centroid[1]} r={2} />
        <line
          x1={centroid[0]}
          y1={centroid[1]}
          x2={inflexionPoint[0]}
          y2={inflexionPoint[1]}
          stroke={"black"}
          fill={"black"}
        />
        <line
          x1={inflexionPoint[0]}
          y1={inflexionPoint[1]}
          x2={labelPosX}
          y2={inflexionPoint[1]}
          stroke={"black"}
          fill={"black"}
        />
        <text
          x={labelPosX + (isRightLabel ? 2 : -2)}
          y={inflexionPoint[1]}
          textAnchor={textAnchor}
          dominantBaseline="middle"
          fontSize={14}
        >
          {label}
        </text>
      </g>
    );
  });

  return (
    <svg width={width} height={height} style={{ display: "inline-block" }}>
      <g
        transform={`translate(${width / 2}, ${height / 2})`}
        className={"container"}
        ref={ref}
      >
        {shapes}
      </g>
    </svg>
  );
};